import { render, staticRenderFns } from "./RiskTypesModal.vue?vue&type=template&id=428839d6&"
import script from "./RiskTypesModal.vue?vue&type=script&lang=ts&"
export * from "./RiskTypesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports